import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CurrentUserService } from '@/app/core/current-user/current-user.service';

/** Ensures the federated actor (roles/permissions) is loaded before a guarded route renders. */
export const currentUserGuard: CanActivateFn = async () => {
    const currentUser = inject(CurrentUserService);
    try {
        await currentUser.ensureLoaded();
    } catch {
        // Render anyway — gated actions stay hidden rather than blocking the whole shell.
    }
    return true;
};
